import sample from 'lodash/sample';
import sampleSize from 'lodash/sampleSize';
import intersection from 'lodash/intersection';
import { OptionType } from '@/types/common';
import { getArticleTags, getArticlesByTags } from '@/api/tanzhi';

type PostType = {
  id: number;
  title: { rendered: string };
  date: string;
  excerpt: { rendered: string };
  link: string;
  featured_media: number;
  categories?: number[];
};

export const getJobTitlePagePosts = async ({
  name,
  l1_l2_list,
  size = 3,
}: {
  name: string;
  l1_l2_list?: OptionType[];
  size?: number;
}) => {
  const arrTagsId: string[][] = [[], [], [], []];
  const tagsResponse = await getArticleTags();
  const tags = tagsResponse.status === 200 ? tagsResponse.data : [];
  tags.map((tag: { id: string; name: string }) => {
    if (name === tag.name) {
      arrTagsId[0].push(tag.id);
      return;
    }
    const tagIndex = l1_l2_list
      ? l1_l2_list.findIndex((jobTitle: any) => jobTitle.name === tag.name)
      : -1;
    if (tagIndex >= 0) {
      arrTagsId[0].push(tag.id);
    }
    if (tag.name === '简历建议') {
      arrTagsId[1].push(tag.id);
    }
    if (tag.name === '求职') {
      arrTagsId[2].push(tag.id);
    }
    if (tag.name === '团队文化') {
      arrTagsId[3].push(tag.id);
    }
  });
  const arrTagsFirstId = [...arrTagsId[0]];
  if (arrTagsFirstId.length > 0) {
    const sampleId = sample(arrTagsFirstId);
    sampleId && arrTagsId.splice(0, 1, [sampleId]);
  }
  const tagIds = arrTagsId.flat();
  const response = await Promise.all(tagIds.map((id) => getArticlesByTags(id)));
  const articles: PostType[][] = await Promise.all(
    response.map((item) => (item.status === 200 ? item.data : [])),
  );
  const posts: PostType[] = [];
  articles.forEach((item) => {
    if (item.length > 0) {
      const samplePost = sampleSize(item, 2);
      samplePost && posts.push(...samplePost);
    }
  });
  return posts.slice(0, size);
};

export const getCityPagePosts = async () => {
  const articleTagsResponse = await getArticleTags();
  const tags =
    articleTagsResponse.status === 200 ? articleTagsResponse.data : [];
  const arrTagsId: string[][] = [[], []];
  tags.map((item: any) => {
    if (item.name === '求职') {
      arrTagsId[0].push(item.id);
    }
    if (item.name === '团队文化') {
      arrTagsId[1].push(item.id);
    }
  });
  const arrPosts: PostType[][] = [[], []];
  const tagsIds = arrTagsId.map((innerArray) => innerArray.join(',')).join(',');
  const articlesResponse = await getArticlesByTags(tagsIds);
  const articles = articlesResponse.status === 200 ? articlesResponse.data : [];
  articles.forEach((article: any) => {
    const idx = arrTagsId.findIndex(
      (item) => intersection(item, article.tags).length > 0,
    );
    if (idx >= 0) {
      arrPosts[idx].push(article);
    }
  });

  const posts: PostType[] = [];
  arrPosts.forEach((item) => {
    const samplePost = sampleSize(item, 2);
    samplePost && posts.push(...samplePost);
  });
  return posts;
};
